import React, {useEffect, useState} from 'react'

//import { toast } from 'react-toastify' //npm i react-toastify

import getDataFromApi from '../../api/getDataFromApi'
import loader from './../../../img/preLoader.gif'
import OrderPayAddPayItems from './OrderPayAddPayItems'

export default function WorkerPaysIndex(props) {

    const {orderData, payData, reloadResponse, responsePayData, reloadOrder, notShowItems } = props;

    //console.log('orderData :>> ', orderData);

    const [response, setRequest] = useState(reloadResponse)
    const [loading, setLoading] = useState(false)

    useEffect(() => {
      
      setRequest(false);

    }, [ reloadResponse ])


    if(!response && !loading) {

        const send = {
            orderId: orderData.id,
          }
    
        sendtoApi('getNurseMoney', 'NursesPays', send, setLoading, setRequest);

    }

    return (
    <div className='WorkerPaysIndex'>
        
        <img src={loader} alt="loader" className={!loading ? 'loader': 'loader active animate__animated animate__fadeIn'} />
        
        

        { (response && !notShowItems) && <OrderPayAddPayItems showTravelExpenses = {true} reloadData={ () => reloadOrder() } payData={responsePayData} orderData={orderData} /> }


        <h2>תשלום לפי משמרת:</h2>

        {response && <div className='nursePaysResultCont'>

            {/* {console.log('responseMoney', response.money)} */}

            {!response?.ok ? <div className='errorMessage'>
                    <span>{ response?.error ? response?.error : 'שגיאה' }</span>
            </div> : <div className='okCont'>
                
                { (response?.money && response.money.text && response.money.text.length > 0 ) && <ul>
                    
                    <li className='contractName'><span>שם החוזה:</span> <strong>{response.money.contractName}</strong></li>

                    {/* שעות בסיס */}
                    <li>
                      משעה: {response.money.baseStartTime || response.money.nurseStart} - לשעה: {response.money.baseEndTime || '06:00'} - מחיר לשעה <small>₪</small>{response.money.baseHourlyRate || response.money.text?.[0]?.priceHour} ({response.money.baseHours || 7} שעות) - <strong><small>₪</small>{response.money.basePrice}</strong>
                    </li>

                    {/* שעות נוספות */}
                    {response?.money?.extraHours?.result > 0 && <li>
                      משעה: {response.money.overtimeStartTime || '06:00'} - לשעה: {response.money.overtimeEndTime || response.money.nurseStop} - מחיר לשעה <small>₪</small>{response.money.extraHours.calculatePrice} ({response.money.extraHours.totalExtra} שעות נוספות ב-125%) - <strong><small>₪</small>{response.money.extraHours.result}</strong>
                    </li>}

                    {/* סיכום */}
                    <li className='totalAmount'>
                      לתשלום: <strong><small>₪</small>{response.money.resultPrice}</strong>
                      {payData?.payItems.count > 0 && <>
                        <span> + </span><small>₪</small>{payData.payItems.count}
                        <small> (תוספות)</small>
                      </>}
                    </li>
                </ul> }

            </div>}
            

        </div>}

        
    </div>
  )
}

function sendtoApi(url, controller, objectToSend, setLoading, setRequest) {

    setLoading(true)
    const getData = getDataFromApi(url, objectToSend, controller, 'all')
  
    getData.then((getData) => {

        //console.log(getData);
        setRequest(getData);
      /* if (getData.ok) {

        //setRequest(getData)
        //toast.success(getData.ok)

      } else if (getData.error) {

        //toast.error(getData.error)
      } */
    })
  
    getData.catch((error) => {
      console.log(error)
      setRequest(getData);
    })
  
    getData.finally(() => {
      setLoading(false)
    })
  }